<template>
  <v-col :cols="12" :sm="12" :md="12">
    <v-alert type="error" v-show="erro">{{ mensagemErro }}</v-alert>

    <v-alert
      v-show="newNotify.isNewNotify"
      border="left"
      close-text="Close Alert"
      color="green accent-4"
      dark
      @click="fecharNotificacao"
    >
      {{ newNotify.text }}
    </v-alert>

    <DataTable
      v-show="showSkeletonTable == false"
      :tableTitle="'Histórico de Dispensas'"
      :tableHeader="headers"
      :tableRows="dispensas"
      :isView="true"
      :isFinish="false"
      :isDel="false"
      :isPrint="false"
      v-on:datatable-viewrow="visualizarHistoricoDispensa"
    ></DataTable>

    <SkeletonTable
      v-show="showSkeletonTable == true"
      :showSkeletonTable="showSkeletonTable"
    ></SkeletonTable>

    <Loading :open="loading" />

    <FormModal
      :isTheModalOpen="formModalData.isOpen"
      :modalButtonText="formModalData.buttonText"
      :modalFormTitle="formModalData.formTitle"
      :modalType="formModalData.modalType"
      :isModalButtonVisible="formModalData.isButtonsVisible"
      :isModalButtonDisabled="formModalData.isButtonsDisabled"
      v-on:formmodal-close="formModalData.isOpen = false"
    >
      <v-col cols="6">
        <v-text-field
          v-model="formModalData.actualEdit.nomeEndereco"
          name="nomeEndereco"
          label="Nome da Unidade"
          readonly
        ></v-text-field>
      </v-col>

      <v-col cols="6">
        <v-text-field
          v-model="formModalData.actualEdit.nomeResponsavel"
          name="nomeResponsavel"
          label="Nome do Responsavel pela Unidade"
          readonly
        ></v-text-field>
      </v-col>

      <v-col cols="6">
        <v-text-field
          v-model="formModalData.actualEdit.dataDispensa"
          name="dataDispensa"
          label="Data Dispensa"
          readonly
        ></v-text-field>
      </v-col>

      <v-col cols="6">
        <v-text-field
          v-model="formModalData.actualEdit.nomeFuncionario"
          name="nomeFuncionario"
          label="Responsável pela Dispensa"
          readonly
        ></v-text-field>
      </v-col>

      <v-col cols="12">
        <DataTable
          v-show="showSkeletonTableModal == false"
          :tableTitle="'Produtos na Dispensa'"
          :tableHeader="headersItens"
          :tableRows="formModalData.actualEdit.itensDispensa"
          :isEdit="false"
          :isFinish="false"
          :isDel="false"
          :isPrint="false"
        ></DataTable>

        <SkeletonTable
          v-show="showSkeletonTableModal == true"
          :showSkeletonTable="showSkeletonTable"
        ></SkeletonTable>
      </v-col>
    </FormModal>
  </v-col>
</template>

<script>
import DataTable from "@/components/DataTable2.vue";
import axios from "../plugins/axios";
import FormModal from "@/components/FormModal.vue";
import store from "@/store/index";
import Loading from "../components/Loading.vue";
import SkeletonTable from "../components/SkeletonTable";

export default {
  components: {
    DataTable,
    FormModal,
    Loading,
    SkeletonTable,
  },

  sockets: {
    reciveInsert: function (data) {
      if (data && data.descricaoTela == "dispensa") {
        this.newNotify.isNewNotify = true;
        this.newNotify.text = "Nova Dispensa recebida!";
        this.initialize();
      }
    },
  },

  data: () => ({
    newNotify: {
      isNewNotify: false,
      text: "",
    },

    erro: false,
    mensagemErro: "Erro",
    showSkeletonTable: true,
    showSkeletonTableModal: true,
    loading: false,

    headers: [
      {
        text: "ID",
        value: "numeroHistoricoDispensa",
      },
      {
        text: "Responsável pela Unidade",
        value: "dispensas.endereco.nomeResponsavel",
      },
      {
        text: "Unidade",
        value: "dispensas.endereco.nomeEndereco",
      },
      {
        text: "Quantidade de Produtos Dispensados",
        value: "dispensas.quantidadeDispensa",
      },
      {
        text: "Data Dispensa",
        value: "dispensas.dataDispensa",
      },
      {
        text: "Responsável pela Dispensa",
        value: "dispensas.funcionario.nomeFuncionario",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],

    
    headersItens: [
      {
        text: "ID",
        value: "numeroItem",
      },
      {
        text: "Lote",
        value: "lote",
      },
      {
        text: "Nome Produto",
        value: "nomeItem",
      },
      {
        text: "Validade",
        value: "validade",
      },
      {
        text: "Qt. Dispensada",
        value: "quantidadeDispensadas",
      },
      {
        text: "Qt. Recebida",
        value: "quantidadeRecebidaItem",
      },
      {
        text: "Qt. em Estoque",
        value: "quantidadeAtual",
      },
    ],

    formModalData: {
      isOpen: false,
      buttonText: "",
      formTitle: "",
      isEdit: false,
      isButtonsDisabled: false,
      isButtonsVisible: false,
      actualEdit: {
        nomeEndereco: null,
        nomeResponsavel: null,
        dataDispensa: null,
        nomeFuncionario: null,
        itensDispensa: [],
      },
    },

    dispensas: [],
  }),

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      try {
        await this.returnHistoricoDispensa();
      } catch (error) {
        console.log(error);
      }
    },

    _formatStringInBrazilianDateFormat(data) {
      if (!data) return null;
      let ano = data.split("-")[0];
      let mes = data.split("-")[1];
      let dia = data.split("-")[2];
      let dia2 = dia.substring(0, 2);

      // Utilizo o .slice(-2) para garantir o formato com 2 digitos.
      return ("0" + dia2).slice(-2) + "/" + ("0" + mes).slice(-2) + "/" + ano;
    },

    async returnHistoricoDispensa() {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": store.state.token,
        },
      };

      let listHistorico = await axios.get("historicoDeDispensas", config);

      for (let value of listHistorico.data) {
        value.dataDispensaPrevia = this._formatStringInBrazilianDateFormat(
          value.dataDispensaPrevia
        );
        value.dispensas.dataDispensa = this._formatStringInBrazilianDateFormat(
          value.dispensas.dataDispensa
        );
      }
      this.showSkeletonTable = false;
      this.dispensas = listHistorico.data;
    },

    visualizarHistoricoDispensa(value) {
      this.loading = true
      this.showSkeletonTableModal = true
      this.formModalData.isOpen = true;
      this.formModalData.isEdit = true;
      this.formModalData.formTitle = "Dispensa";

      this.formModalData.actualEdit.nomeEndereco = value.dispensas.endereco.nomeEndereco;
      this.formModalData.actualEdit.nomeResponsavel = value.dispensas.endereco.nomeResponsavel;
      this.formModalData.actualEdit.dataDispensa = value.dispensas.dataDispensa;
      this.formModalData.actualEdit.nomeFuncionario = value.dispensas.funcionario.nomeFuncionario;
      this.formModalData.actualEdit.itensDispensa = value.dispensas.itens;

      this.showSkeletonTableModal = false
      this.loading = false
    },

    fecharNotificacao() {
      this.newNotify.isNewNotify = false;
    },
  },
};
</script>